module.exports = __webpack_public_path__ + "img/no_friend_request.c0c24c57.png";